export const environment = {
  production: false,
  ccitySimulateEnabled: true,
  MOCK_API_URL: 'https://devapi.pactrak.com',
  API_BASE_URL: 'https://devapi.pactrak.com',
  b2cRedirectURL: 'https://dev.pactrak.com/',
  B2CName:'B2C_1_dev-pactrak',
  clientId:'221c2702-206c-4c3f-9cfa-f4eb7b1dcd32',
  B2CApiName:'dev-pactrak-api',
  azureCDNAccountsData: 'https://pactrakcdn.z13.web.core.windows.net/account-summary-help.json',
  azureCDNAdvancedSearchHelp: 'https://pactrakcdn.z13.web.core.windows.net/advanced-search-help.json',
  azureCDNUserManagementHelp: 'https://pactrakcdn.z13.web.core.windows.net/user-management-summary-help.json',
  azureCDNShortcutKeysCatalog: 'https://pactrakcdn.z13.web.core.windows.net/shortcut-keys.catalog.json',
  azureCDNRolesAndPermissionHelp: 'https://pactrakcdn.z13.web.core.windows.net/roles-and-permissions-summary-help.json',
  // Telemetry configuration
  telemetry: {
    enabled: true,
    fallbackToConsole: true,
  },
  newRelicBrowser: {
    enabled: true,
    accountID: '8312878',
    trustKey: '8312878',
    agentID: '601662910',
    licenseKey: 'NRJS-da7e4985f5766aa18fc',
    applicationID: '601662910',
    allowedOrigins: ['https://devapi.pactrak.com'],
  },
  // Roles & Permissions Enforcement configuration
  rolesPermissionsEnforcement: {
    enabled: true,
  },
  b2authority: 'https://pactrakuser.b2clogin.com/pactrakuser.onmicrosoft.com/',
  authorityDomain: 'pactrakuser.b2clogin.com',
  protectedResources: 'https://pactrakuser.onmicrosoft.com/'
};
